import { Component, OnInit, DestroyRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RouterLink, Router } from '@angular/router';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { AuthService } from '../../../../_services/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UserRole } from '../../../../_interfaces/enums.interface';

@Component({
  selector: 'app-login',
  imports: [ButtonComponent, RouterLink, CommonModule, ButtonComponent, RouterLink, ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  showPassword = false;
  errorMessage: string = '';
  loading = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  onSubmit(): void {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }
    this.loading = true;
    this.errorMessage = '';

    const { username, password } = this.loginForm.value;

    this.authService.login({ username, password })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res: any) => {
          this.loading = false;
          const role: UserRole = res.role;
          switch (role) {
            case 'Admin':
              this.router.navigate(['/dashboard/admin']);
              break;
            case 'Startup':
              this.router.navigate(['/dashboard/startup']);
              break;
            case 'Incubator':
              this.router.navigate(['/dashboard/incubator']);
              break;
            default:
              this.errorMessage = 'Unknown user role. Please contact support.';
              break;
          }
        },
        error: (err) => {
          this.loading = false;
          this.errorMessage = err.error?.message || 'Login failed. Please check your credentials and try again.';
        }
      });
  }
}

